const version = "7.1.1";
export {
  version
};
//# sourceMappingURL=package.json.js.map
